import React from 'react';
import ParentLayout from '@/pages/evaluations-event-partners-filtered/Layout';
import useRouter from '@/hooks/useRouter';
import useQuery from './useQuery';
import Evaluation from './Evaluation';
import useSchoolYearParams from '@/pages/evaluations/useSchoolYearParams';
import queryString from 'query-string';

export default function Layout(_props) {
  const { location } = useRouter();

  const params = useSchoolYearParams();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    search: queryString.parse(location.search),
    PAGE_SIZE,
    network: params.network,
    schoolStart: params.schoolStart,
    schoolEnd: params.schoolEnd
  });

  return (
    <ParentLayout
      location={location}
      extra={{
        schoolStart: params.schoolStart,
        schoolEnd: params.schoolEnd,
        variant: 'testimonials'
      }}
      breadcrumbs={['Evaluations', 'Events: Partners']}
      title="Testimonials"
      description={
      <>
          Testimonials provided by a partner as part of their event evaluation.
        </>
      }
      pageSize={PAGE_SIZE}
      result={result}
      row={function (evaluationEventPartner) {
        return (
          <Evaluation
            key={evaluationEventPartner.id}
            evaluation={evaluationEventPartner} />);


      }} />);


}